import Model from '@/models/Model'

export const OPEN_BANKING_PAYMENT_STATUSES = {
  INITIATED: 'INITIATED',
  PROCESSING: 'PROCESSING',
  CONFIRMED: 'CONFIRMED',
  CANCELED: 'CANCELED',
  FAILED: 'FAILED'
}

export default class OpenBankingPayment extends Model {
  static get statusOptions () {
    return [
      { name: 'Initiated', value: OPEN_BANKING_PAYMENT_STATUSES.INITIATED },
      { name: 'Processing', value: OPEN_BANKING_PAYMENT_STATUSES.PROCESSING },
      { name: 'Confirmed', value: OPEN_BANKING_PAYMENT_STATUSES.CONFIRMED },
      { name: 'Canceled', value: OPEN_BANKING_PAYMENT_STATUSES.CANCELED },
      { name: 'Failed', value: OPEN_BANKING_PAYMENT_STATUSES.FAILED }
    ]
  }

  get schema () {
    return [
      'id',
      'bilderAccountPaymentId',
      'applicationPaymentId',
      'institutionId',
      'institutionClientId',
      'institutionPaymentStatus',
      'institutionIsoStatus',
      'status',
      'amount',
      'currency',
      'description',
      'sender',
      'recipient',
      'applicationCustomerId',
      'applicationId',
      'applicationName',
      'applicationReturnUrl',
      'createdAt',
      'receiverProfileId'
    ]
  }
}
